var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"material-template-page"}},[_c('div',{staticClass:"material-content"},[(
        _vm.material.url &&
        (_vm.material.url.indexOf('pdf') > -1 || _vm.material.url.indexOf('doc') > -1)
      )?_c('div',{staticClass:"view-pdf"},[(_vm.material.url)?_c('iframe',{attrs:{"src":_vm.material.url,"frameborder":"0"}}):_vm._e()]):_vm._e(),(
        _vm.material.url &&
        _vm.material.url.indexOf('doc') < 0 &&
        _vm.material.url.indexOf('pdf') < 0
      )?_c('div',[_c('img',{attrs:{"src":_vm.material.url}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }